import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Text } from 'common-components'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import projectDataSlice from 'store/features/projectData/slice'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { dispatch } from 'store'
import { ITextData } from 'types/media'
import * as Styled from './styled'
import { FontDropdown } from './components/font-dropdown'
import { TextInput } from './components/text-input'
import { StylesContainer } from './components/styles-container'
import { useFontLoading } from './hooks/use-font-loading'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

const projectDataActions = projectDataSlice.actions

const TextOverlayContent = () => {
  const mediaItem = useSelector(projectDataSelectors.activeMedia)
  const textData = mediaItem?.meta?.textData
  const itemId = `${mediaItem?.id}-${mediaItem?.assetId}`
  const isFontLoading = useFontLoading(mediaItem?.id)

  const persistTextData = useCallback(
    (
      patch: Partial<ITextData>,
      sizeOverrides?: { width: number; height: number }
    ) => {
      if (!mediaItem || !textData) return

      dispatch(
        projectDataActions.updateMediaItem({
          id: mediaItem.id,
          updates: {
            ...sizeOverrides,
            meta: { ...mediaItem.meta, textData: { ...textData, ...patch } }
          }
        })
      )
    },
    [mediaItem, textData]
  )

  const handleDelete = useCallback(() => {
    dispatch(projectDataThunks.removeTimelineSelectedItems())
  }, [])

  if (!mediaItem || !textData) return null

  return (
    <Styled.Container>
      <Styled.Header>
        <Text type="h1" color="secondaryDark" fontWeight="600">
          {translate(T.EDIT_YOUR_TEXT_LABEL)}
        </Text>
      </Styled.Header>

      <Styled.Content>
        <TextInput
          persistTextData={persistTextData}
          text={textData.text}
          mediaItemId={itemId}
          onDelete={handleDelete}
          id={mediaItem.id}
        />
        <FontDropdown
          fontPostScriptName={textData.fontPostScriptName}
          persistTextData={persistTextData}
          isFontLoading={isFontLoading}
        />
        <StylesContainer
          persistTextData={persistTextData}
          originalId={mediaItem.id}
          textData={textData}
        />
      </Styled.Content>
    </Styled.Container>
  )
}

export default TextOverlayContent
